import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Row } from "react-bootstrap";
import { PencilIcon } from '@primer/octicons-react'
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';


const DatapointTypeAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [datapointTypeAttrs, setDatapointTypeAttrs] = useState({
    code: '',
    description: '',
    category: '',
    type: '',
    subsystem: '',
    dataType: '',
    unit: '',
    formula: ''
  });

  const [currentDatapointTypeAttrs, setCurrentDatapointTypeAttrs] = useState({});


  const categoryList = [
    { key: "DATA",  value: "DATA" },
    { key: "ALARM", value: "ALARM" }
  ];

  const typeList = [
    { key: "DIRECT",  value: "DIRECT" },
    { key: "DERIVED", value: "DERIVED" }
  ];

  const [subsystemList,   setSubsystemList]   = useState([]);
  const [dataTypeOptions, setDataTypeOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);


  // UI Functions

  // Initialize state
  useEffect(() => {
    if (props) {
      setDatapointTypeAttrs(props.objDetails);
      setCurrentDatapointTypeAttrs(props.objDetails);
    }

    fetchSubsystems();
    fetchDataTypes();
    fetchUnits();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const fetchSubsystems = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("subsystems");

        resolve(res.data);

        if (res.status === 200) {
          setSubsystemList(res.data);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  const fetchDataTypes = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("tr-data-types");

        resolve(res.data);

        if (res.status === 200) {
          setDataTypeOptions(res.data);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  const fetchUnits = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("tr-units");

        resolve(res.data);

        if (res.status === 200) {
          setUnitOptions(res.data);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  // View vs Edit Modes
  const [editMode, setEditMode] = useState(false);

  const [errMsg,             setErrMsg]             = useState('');
  const [errMsg_Update,      setErrMsg_Update]      = useState('');

  //const [datapointList, setDatapointList] = useState([]);

  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }


  const onAttrsInputChange = (e) => {
    setDatapointTypeAttrs({ ...datapointTypeAttrs, [e.target.name]: e.target.value })
  }

  const onCategorySelect = (key, event) => {
    setDatapointTypeAttrs({ ...datapointTypeAttrs, category: key })
  };

  const onTypeSelect = (key, event) => {
    setDatapointTypeAttrs({ ...datapointTypeAttrs, type: key })
  };

/*
  const onSubsystemSelect = (id, event) => {
    setDatapointTypeAttrs({ ...datapointTypeAttrs, subsystemId: id })
  };
*/
  const onSubsystemClick = (id) => {
    setDatapointTypeAttrs({ ...datapointTypeAttrs, subsystemId: id })
  };

  const onDataTypeSelect = (code, event) => {
    setDatapointTypeAttrs({ ...datapointTypeAttrs, dataType: code })
  };

/*
  const onUnitSelect = (code, event) => {
    setDatapointTypeAttrs({ ...datapointTypeAttrs, unit: code })
  };
*/
  const onUnitClick = (code) => {
    setDatapointTypeAttrs({ ...datapointTypeAttrs, unit: code })
  };

  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setDatapointTypeAttrs(currentDatapointTypeAttrs);

    setEditMode(false);
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    if (datapointTypeAttrs.description && datapointTypeAttrs.description.length > 200) {
      setErrMsg_Update(t("I18N_ERR_Max_len_desc") + 200);
      return;
    }

    const reqBody = datapointTypeAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.put("datapoint-types/" + datapointTypeAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          refreshDatapointTypeAttrs(datapointTypeAttrs.id);

          // Restore UI to viewing mode
          setEditMode(false);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_Update(t(translateAPIError(error)));
        }
      }
    });
  }


  const refreshDatapointTypeAttrs = (datapointTypeId) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("datapoint-types/" + datapointTypeId);

        resolve(res.data);

        if (res.status === 200) {

          setDatapointTypeAttrs(res.data[0]);
          setCurrentDatapointTypeAttrs(res.data[0]);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', height:'600px', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_DatapointType_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_DatapointType_info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Datapoint_type_code")}: *</Col>
                  <Col>{t("I18N_Description")}:</Col>
                  <Col>{t("I18N_Data_type")}: *</Col>
                  <Col>{t("I18N_Unit")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>{datapointTypeAttrs.code}</Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description" value={datapointTypeAttrs.description}
                              onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!datapointTypeAttrs.dataType ? t("common:I18N_DROPDOWN_PROMPT") :
                              t("common:I18N_" + (dataTypeOptions.find( ({ code }) => code === datapointTypeAttrs.dataType )).code) }
                      onSelect={onDataTypeSelect}>
                      {dataTypeOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.code} className={classes.dropdown_item_wrap}>
                            {t("common:I18N_" + item.code)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                  <Col>
{/*
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!datapointTypeAttrs.unit ? t("common:I18N_DROPDOWN_PROMPT") :
                              (unitOptions.find( ({ code }) => code === datapointTypeAttrs.unit )).code}
                      onSelect={onUnitSelect}>
                      {unitOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.code} className={classes.dropdown_item_wrap}>
                            {item.code}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
*/}
                    <Dropdown>
                      <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                        {!datapointTypeAttrs.unit ? t("common:I18N_DROPDOWN_PROMPT") :
                         ((unitOptions.find( ({ code }) => code === datapointTypeAttrs.unit )).description +
                           ((unitOptions.find( ({ code }) => code === datapointTypeAttrs.unit )).symbol ?
                            ' (' + (unitOptions.find( ({ code }) => code === datapointTypeAttrs.unit )).symbol + ')' : '')) }
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                        {unitOptions.map((item, index) => {
                          return (
                            <Dropdown.Item key={index} style={{maxHeight:'100px'}} eventKey={item.code} className={classes.dropdown_item_wrap}
                              onClick={() => onUnitClick(item.code)}>
                              {item.description + (item.symbol ? ' (' + item.symbol + ')' : '')}
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>

                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Category")}: *</Col>
                  <Col>{t("I18N_Type")}: *</Col>
                  <Col>{t("I18N_Subsystem")}: *</Col>
                  <Col>{t("I18N_Formula")}: </Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!datapointTypeAttrs.category ? t("common:I18N_DROPDOWN_PROMPT") : t("common:I18N_" + datapointTypeAttrs.category) }
                      onSelect={onCategorySelect}>
                      {categoryList.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("common:I18N_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!datapointTypeAttrs.type ? t("common:I18N_DROPDOWN_PROMPT") : t("common:I18N_" + datapointTypeAttrs.type) }
                      onSelect={onTypeSelect}>
                      {typeList.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("common:I18N_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                  <Col>
{/*
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!datapointTypeAttrs.subsystemId ? t("common:I18N_DROPDOWN_PROMPT") :
                              (subsystemList.find( ({ id }) => id === parseInt(datapointTypeAttrs.subsystemId) )).code}
                      onSelect={onSubsystemSelect}>
                      {subsystemList.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap}>
                            {item.code}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
*/}
                    <Dropdown>
                      <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                        {!datapointTypeAttrs.subsystemId ? t("common:I18N_DROPDOWN_PROMPT") :
                           (subsystemList.find( ({ id }) => id === parseInt(datapointTypeAttrs.subsystemId) )).code}
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                        {subsystemList.map((item, index) => {
                          return (
                            <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap}
                              onClick={() => onSubsystemClick(item.id)}>
                              {item.code}
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>

                  </Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="formula" value={datapointTypeAttrs.formula}
                              onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg_Update}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Datapoint_type_code")}:</Col>
                <Col>{t("I18N_Description")}:</Col>
                <Col>{t("I18N_Data_type")}:</Col>
                <Col>{t("I18N_Unit")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{datapointTypeAttrs.code}</Col>
                <Col>
                  <textarea readOnly className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="desc_readonly"
                            value={datapointTypeAttrs.description} />
                </Col>
                <Col>
                  {(dataTypeOptions.find( ({ code }) => code === datapointTypeAttrs.dataType )) ?
                   t("common:I18N_" + (dataTypeOptions.find( ({ code }) => code === datapointTypeAttrs.dataType )).code) : ''}
                </Col>
                <Col>
                  {(unitOptions.find( ({ code }) => code === datapointTypeAttrs.unit )) ?
                   ((unitOptions.find( ({ code }) => code === datapointTypeAttrs.unit )).description +
                      ((unitOptions.find( ({ code }) => code === datapointTypeAttrs.unit )).symbol ?
                        (' (' + (unitOptions.find( ({ code }) => code === datapointTypeAttrs.unit )).symbol + ')')
                      : ''))
                  : '' }
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Category")}: </Col>
                <Col>{t("I18N_Type")}: </Col>
                <Col>{t("I18N_Subsystem")}: </Col>
                <Col>{t("I18N_Formula")}: </Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{t("common:I18N_" + datapointTypeAttrs.category)}</Col>
                <Col>{t("common:I18N_" + datapointTypeAttrs.type)}</Col>
                <Col>{datapointTypeAttrs.subsystem}</Col>
                <Col>{datapointTypeAttrs.formula}</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{overflowWrap:'anywhere'}}>{datapointTypeAttrs.creatorUsername}</Col>
                <Col>{formatDate(datapointTypeAttrs.timeCreated)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{datapointTypeAttrs.updaterUsername}</Col>
                <Col>{formatDate(datapointTypeAttrs.timeUpdated)}</Col>
              </Row>

            </Container>
          }
        </div>


        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} >
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
{/*
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: 'auto', fontSize: '12px', fontWeight: '300' }}
                onClick={handleInspectData}>
                {t("I18N_Inspect_data")}
              </Button>
*/}
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '0px', fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top', marginLeft: '0' }}>
                {errMsg}
              </span>
            </div>
          </Form.Group>
        </div>

      </Card>
    </>
  );
}

export default DatapointTypeAdminDetailsView;
